import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/join')({
  head: () => {
    const p = getStaticPage('join');
    return staticHead({ pathname: '/join', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="join" />,
});
